export default __webpack_public_path__ + "static/favicon-75ec58f5353c31bcd8ec79a7fa403789.ico";